var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.143555,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#EAEAEA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10481_23928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.9 19C9.9 17.29 11.29 15.9 13 15.9H17V14H13C10.24 14 8 16.24 8 19C8 21.76 10.24 24 13 24H17V22.1H13C11.29 22.1 9.9 20.71 9.9 19ZM14 20H22V18H14V20ZM23 14H19V15.9H23C24.71 15.9 26.1 17.29 26.1 19C26.1 20.71 24.71 22.1 23 22.1H19V24H23C25.76 24 28 21.76 28 19C28 16.24 25.76 14 23 14Z",
    fill: "#787878"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10481_23928"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectLink);
export default __webpack_public_path__ + "static/media/directLink.9a25e1d16f6a3d8f404f510806b58e8b.svg";
export { ForwardRef as ReactComponent };